import { useEffect, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { Pagination as BootstrapPagination } from "react-bootstrap";

function Page({ pageNumber, children }) {
  const { asPath, isReady } = useRouter();
  const [path, setPath] = useState("");

  useEffect(() => {
    if (isReady)
      setPath(asPath);
  }, [isReady, asPath]);

  return (
    <Link
      href={{
        pathname: path.split("?")[0],
        query: { page: pageNumber },
      }}
      passHref
      shallow
      scroll
    >
      <BootstrapPagination.Item>{children}</BootstrapPagination.Item>
    </Link>
  );
}

function Pagination({ activePage, maxPages, pageRangeDisplayed }) {
  let range = [];

  for (var i = 1; i <= maxPages; i++)
    if (i === activePage)
      range.push(
        <BootstrapPagination.Item key={i} className="active">
          <b>
            {i} <span className="visually-hidden">(current)</span>
          </b>
        </BootstrapPagination.Item>
      );
    else if (
      i > activePage - pageRangeDisplayed &&
      i < activePage + pageRangeDisplayed
    )
      range.push(
        <Page key={i} pageNumber={i}>
          <b>{i}</b>
        </Page>
      );

  return (
    <div>
      <BootstrapPagination className="justify-content-center my-3">
        {activePage > 1 ? (
          <>
            <Page pageNumber={1}>
              <b>first</b>
            </Page>
            <Page pageNumber={activePage - 1}>
                <b>&laquo;</b>
            </Page>
          </>
        ) : (
          <BootstrapPagination.Item disabled>
            <b>&laquo;</b>
          </BootstrapPagination.Item>
        )}
        {range}
        {activePage < maxPages ? (
          <>
            <Page pageNumber={activePage + 1}>
              <b>&raquo;</b>
            </Page>
            <Page pageNumber={maxPages}>
              <b>last</b>
            </Page>
          </>
        ) : (
          <BootstrapPagination.Item disabled>
            <b>&raquo;</b>
          </BootstrapPagination.Item>
        )}
      </BootstrapPagination>
    </div>
  );
}

export default Pagination;
